import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import './config/api' // Ensures fetch is patched to add JWT for API requests
import App from './App.jsx'
import './index.css'

// Open the native calendar whenever a date field is clicked (not just its tiny icon).
// Keyboard entry still works: Tab-focus alone does not open it, and Escape closes it.
document.addEventListener('click', (e) => {
  const el = e.target
  if (
    el instanceof HTMLInputElement &&
    (el.type === 'date' || el.type === 'datetime-local' || el.type === 'month') &&
    !el.disabled &&
    !el.readOnly &&
    typeof el.showPicker === 'function'
  ) {
    try { el.showPicker() } catch (_) { /* already open, or not allowed in this context */ }
  }
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
)
